import React from "react";
import { Box, Tooltip } from "@chakra-ui/react";
import Flyout from "./Flyout";
import { c } from "../classroomColors";
import { COLOURS } from "./boardTools";

/** What the current tool draws with (Figma 205:399). The palette is a prop
 *  so a paper can annotate in marking colours without the board changing. */
const ColourPicker = ({ isOpen, value, onChange, isDark, top, side, colours = COLOURS }) => (
  <Flyout label="Colours" isOpen={isOpen} isDark={isDark} top={top} side={side}>
    {colours.map((colour) => {
      const isActive = colour.value === value;
      return (
        <Tooltip key={colour.id} label={colour.label} placement="top" hasArrow fontSize="11px">
          <Box
            as="button"
            type="button"
            aria-label={colour.label}
            aria-pressed={isActive}
            onClick={() => onChange(colour.value)}
            boxSize="24px"
            borderRadius="full"
            bg={colour.value}
            // The ring, not a border, so the swatch keeps its full size.
            boxShadow={isActive ? `0 0 0 2px ${c.surface}, 0 0 0 4px ${c.text}` : "none"}
            transition="box-shadow 0.15s, transform 0.12s"
            _hover={{ transform: "scale(1.08)" }}
            _focusVisible={{ outline: "2px solid", outlineColor: c.text, outlineOffset: "3px" }}
          />
        </Tooltip>
      );
    })}
  </Flyout>
);

export default ColourPicker;
